// 语言和货币共用的组件
import React from "react";
import styled, { css } from "styled-components";
import { px2rem } from "utils/browser/resizer";
import { AssetImageUrl } from "assets/imgUrls";
import Constant, { setCookie, Host, comCookieLocal } from "utils/headFootConstants";

import getLangKeyValueFun from "utils/lang";
import langGroup from "assets/lang.json";

const gettext = getLangKeyValueFun(langGroup);

const Container = styled.div`
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	z-index: 3000;
	background: #ffffff;
	font-size: ${px2rem(16)};
	color: #333333;
	padding-top: ${px2rem(44)};
`;
const Header = styled.div`
	position: fixed;
	top: 0;
	width: 100%;
	height: ${px2rem(44)};
	padding: 0 ${px2rem(12)};
	border-bottom: 1px solid #e6e6e6;
	box-sizing: border-box;
	> div {
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}
`;
const List = styled.div`
	height: 100%;
	overflow: scroll;
`;
const Close = styled.div`
	position: absolute;
	top: 50%;
	left: ${px2rem(12)};
	transform: translateY(-50%);
`;
const Title = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	font-weight: 800;
`;
const CurrencyItem = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: ${px2rem(44)};
	margin-left: ${px2rem(12)};
	padding-right: ${px2rem(12)};
	border-bottom: 1px solid #e6e6e6;
	> img {
		display: none;
	}
	${(props: { checked?: boolean }) =>
		props.checked &&
		css`
			color: #e33124;
			> img {
				display: block;
			}
		`};
`;
const ItemLeft = styled.div`
	display: flex;
	font-weight: 500;
	> em {
		width: ${px2rem(40)};
		font-style: normal;
	}
`;
const Type = {
	Currency: "Currency",
	Language: "Language",
};
interface LangAndCurProps {
	list: any[];
	title: string;
	stateChange: (key, value) => void;
	onChangeLanguage?: (lan?: string) => void;
}

class LangAndCur extends React.Component<LangAndCurProps, {}> {
	constructor(props) {
		super(props);
		this.state = {
			showSidebar: true,
		};
	}

	componentDidMount() {}

	changeCurrency = (item) => {
		const BaseUrl = Host[String(Constant.isUat)];
		const cookieLocal = comCookieLocal([
			Constant.language,
			Constant.countryCode2,
			item.currency_code,
		]);
		setCookie("local", cookieLocal, "/", BaseUrl.domain);

		setCookie("ci-currency", item.currency_code, "/", BaseUrl.domain);
		window.location.reload();
	};

	changeLanguage = (item) => {
		const BaseUrl = Host[String(Constant.isUat)];
		const cookieLocal = comCookieLocal([
			item.language_code,
			Constant.countryCode2,
			Constant.currency,
		]);
		setCookie("local", cookieLocal, "/", BaseUrl.domain);

		setCookie("ci-language", item.language_code, "/", BaseUrl.domain);

		if (this.props.onChangeLanguage) {
			this.props.onChangeLanguage(item.language_code);
		} else {
			location.reload();
		}
	};

	render() {
		const { list, title, stateChange } = this.props;
		return (
			<Container>
				<Header>
					<Close onClick={() => stateChange(`show${title}Modal`, false)}>
						<img src={AssetImageUrl["ic_back@3x.png"]} width={24} />
					</Close>
					<Title>{gettext(title)}</Title>
				</Header>
				<List>
					{title === Type.Currency && (
						<div>
							{list.map((item, index) => {
								return (
									<CurrencyItem
										key={index}
										checked={item.currency_code === Constant.currency}
										onClick={() => this.changeCurrency(item)}
									>
										<ItemLeft>
											<em>{item.currency_symbol}</em>
											<span>{item.currency_code}</span>
										</ItemLeft>
										<img src={AssetImageUrl["ic_right@3x.png"]} width={24} />
									</CurrencyItem>
								);
							})}
						</div>
					)}
					{title === Type.Language && (
						<div>
							{list.map((item, index) => {
								return (
									<CurrencyItem
										key={index}
										checked={item.language_code === Constant.language}
										onClick={() => this.changeLanguage(item)}
									>
										<ItemLeft>
											<span>{item.language_text}</span>
										</ItemLeft>
										<img src={AssetImageUrl["ic_right@3x.png"]} width={24} />
									</CurrencyItem>
								);
							})}
						</div>
					)}
				</List>
			</Container>
		);
	}
}

export default LangAndCur;
